import { Attributes, Misc, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";
import { TextConstants } from "../../../Common/TextConstants";

@NeoModel
export default class AdhocWACCommand extends ValueObject {

    @Rules.Required()
    @Attributes.Integer()
    public staticServiceProviderFileGroupingID: number = 0;

    public runWACRolloverInd: boolean = true;

    public rawImportLogID: number | null = null;

    @Attributes.Integer()
    public clientAccountID: number | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public rangeStartDate: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public rangeEndDate: Date | null = null;

    @Attributes.Integer()
    public staticInstrumentID: number | null = null;

    public staticInstrumentName: string | null = null;

    public clientAccountName : string | null = null;

    public serviceProviderGroupingName: string | null = null;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen((c) => c.staticServiceProviderFileGroupingID === 0, TextConstants.Validation.ProvideFileGrouping).onProperties((c) => [c.staticServiceProviderFileGroupingID]);

        rules.failWhen((c) => c.rangeStartDate === null, TextConstants.Validation.ProvideStartDate).onProperties((c) => [c.rangeStartDate]);

        rules.failWhen((c) => c.rangeEndDate === null, TextConstants.Validation.ProvideEndDate).onProperties((c) => [c.rangeEndDate]);

        rules.failWhen(
            (c) => c.rangeStartDate !== null && c.rangeEndDate !== null && c.rangeStartDate > c.rangeEndDate,
            TextConstants.Validation.StartDateBeforeEndDate
        ).onProperties((c) => [c.rangeStartDate, c.rangeEndDate]);
    }
}
